import {
  SORT__PRICE__LOW_TO_HIGH,
  TRANSMISSION_DEFAULT,
  CURRENCY_DEFAULT,
  LANG_DEFAULT,
} from '@ott/cars-shared';
import T from '../types';
import LOADER from '@ott/utility-loader';

const initialState = {
  sortingType: SORT__PRICE__LOW_TO_HIGH,
  filters: {
    transmission: TRANSMISSION_DEFAULT,
  },
  commonParams: {
    currency: CURRENCY_DEFAULT,
    lang: LANG_DEFAULT,
    bonusCurrency: undefined,
  },
  params: {},
  variants: {},
  status: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case T.VARIANTS_GET_START: {
      return {
        ...state,
        params: action.params,
        status: LOADER.begin(),
      };
    }

    case T.VARIANTS_GET_SUCCESS: {
      const { variants, isTestResponse } = action;

      return {
        ...state,
        status: LOADER.success(),
        variants,
        isTestResponse,
      };
    }

    case T.VARIANTS_GET_FAIL: {
      return {
        ...state,
        status: LOADER.error(action.error),
      };
    }

    case T.VARIANTS_GET_RESET: {
      return {
        ...initialState,
      };
    }

    case T.FILTER_APPLY: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filter,
        },
      };
    }

    case T.BONUS_CURRENCY_SET: {
      return {
        ...state,
        commonParams: {
          ...state.commonParams,
          bonusCurrency: action.bonusCurrency,
        },
      };
    }

    default:
      return state;
  }
};
